import React, { useEffect, useRef } from 'react';

interface TradingViewWidgetProps {
  symbol: string;
  containerId: string;
}

declare global {
  interface Window {
    TradingView: any;
  }
}

export const TradingViewWidget: React.FC<TradingViewWidgetProps> = ({ symbol, containerId }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Clear any existing children to prevent duplicate widgets
    containerRef.current.innerHTML = `<div id="${containerId}" style="height: 100%; width: 100%;"></div>`;

    const initWidget = () => {
      if (window.TradingView && document.getElementById(containerId)) {
        new window.TradingView.widget({
          autosize: true,
          symbol: symbol,
          interval: 'D',
          timezone: 'Asia/Jakarta',
          theme: 'dark',
          style: '1',
          locale: 'en',
          toolbar_bg: '#111111',
          enable_publishing: false,
          hide_side_toolbar: false, // Show drawing toolbar on the left
          allow_symbol_change: true,
          container_id: containerId,
          studies: [
            'MASimple@tv-basicstudies',
            'StochasticRSI@tv-basicstudies'
          ],
        });
      }
    };

    if (!document.getElementById('tradingview-tv-script')) {
      const script = document.createElement('script');
      script.id = 'tradingview-tv-script';
      script.src = 'https://s3.tradingview.com/tv.js';
      script.type = 'text/javascript';
      script.onload = initWidget;
      document.head.appendChild(script);
    } else {
      if (window.TradingView) {
        initWidget();
      } else {
        const interval = setInterval(() => {
          if (window.TradingView) {
            initWidget();
            clearInterval(interval);
          }
        }, 100);
        return () => clearInterval(interval);
      }
    }
  }, [symbol, containerId]);

  return (
    <div ref={containerRef} className="w-full h-full" style={{ minHeight: '100%' }} />
  );
};
